import * as React from 'react';
import { SVGProps } from 'react';
const SvgCalendarTime = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.9 3.1886H16.1749V1.48755H14.4739V3.1886H8.42575V1.48793H6.7251L6.72472 3.1886H2L2.00038 20.388L11.975 20.388L11.45 18.4979L20.9 13.4575V3.1886ZM11.45 18.4979L3.89004 18.4979V9.70924H19.0103V11.4625L20.9 13.4575L11.45 18.4979ZM3.89004 8.10271V4.88964H6.72472V6.21267H8.42575V4.88964H14.4739V6.21267H16.1749V4.88964H19.0103V8.10271H3.89004Z"
      fill="current"
    />
    <path
      d="M16.7 10.4125C13.2262 10.4125 10.4 13.2387 10.4 16.7125C10.4 20.1864 13.2262 23.0125 16.7 23.0125C20.1738 23.0125 23 20.1864 23 16.7125C23 13.2387 20.1738 10.4125 16.7 10.4125ZM16.7 21.4375C13.9211 21.4375 11.975 19.4915 11.975 16.7125C11.975 13.9336 13.9211 11.9875 16.7 11.9875C19.4789 11.9875 21.425 13.9336 21.425 16.7125C21.425 19.4915 19.4789 21.4375 16.7 21.4375Z"
      fill="current"
    />
    <path
      d="M17.33 13.3681H15.65V16.9734L17.852 19.1702L19.0354 18.1571L17.33 16.4517V13.3681Z"
      fill="current"
    />
  </svg>
);
export default SvgCalendarTime;
